/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

export function ArrUpdate(Arr, children) {
  Arr.forEach(x => {
    if (x[children].length > 0) {
      ArrUpdate(x[children], children)
    } else {
      x[children] = null
    }
  })
}

export function deptUpdateList(data, parent) {
  if (parent) {
    var childrenArr = data.filter(x => x.ParentID === parent.PID)
    if (childrenArr.length) { parent.Depts = childrenArr } else { parent.Depts = null }
    childrenArr.forEach(x => { deptUpdateList(data, x) })
  } else {
    var genArr = data.filter(x => data.filter(z => z.PID === x.ParentID).length === 0)
    genArr.forEach(x => {
      deptUpdateList(data, x)
    })
    return genArr
  }
}

export function getJsonTree(data, ParentID = '',key = 'parentID',keyb='children') {
  var itemArr = []
  if(ParentID){
    itemArr = itemArr.concat(data.filter(x=>x[key] == ParentID))
  }else{
    var genArr = data.filter(x => data.filter(z => z.ID === x[key]).length === 0)
    itemArr = itemArr.concat(genArr)
  }
  for (var i = 0; i < itemArr.length; i++) {
    var node = itemArr[i]
    node[keyb] = node[keyb] || []
    node[keyb] = node[keyb].concat(getJsonTree(data,node.ID,key,keyb))
  }
  return itemArr
}
